// Flags a DD/MM/YYYY date whose year is implausibly far from now — the classic
// OCR misread (e.g. a 2026 invoice read as "26/06/2029" or "26/06/2010"). Such a
// date passes every format check but drops the document into the wrong month, so
// it silently skews the by-month procurement analytics. We surface it as a
// reviewer warning at the point the extracted date is confirmed.
export function isImplausibleDateYear(dateStr, now = new Date()) {
  const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec((dateStr || '').trim());
  if (!m) return false;
  return Math.abs(parseInt(m[3], 10) - now.getFullYear()) > 1;
}
